<script>
import AdminLayout from '@layouts/admin-main'
import PublicOrderList from '@components/admin/public-order-list'

export default {
  page: {
    title: 'PublicOrderList',
    meta: [{ name: 'description', content: 'PublicOrderList' }],
  },
  components: { AdminLayout, PublicOrderList },
}
</script>

<template>
  <AdminLayout>
    <PublicOrderList />
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
